//code for main product slider only for mobile start

if($(window).width() <= 767 ) { 
jQuery('.product__media-list').slick({
      dots: true,
      arrows:true,
      infinite: true,
      speed: 300,
      // centerMode: true,
      // centerPadding: '20px',
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
//code for main product slider only for mobile end